/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IPortScannerJobModalScope extends ng.IScope {
        networkNodes: Models.INetworkNode[];
        selectNetworkNode: () => void;
        modalClose: () => void;
        modalSave: () => void;
        selectedNode: Models.INetworkNode;
        selectedTarget: string;
        ipAddress: string;
        protocol: string;
        portsRaw: string;
        onNodeCheck: () => void;
        selectNode: () => void;
    }

    /**
     * PortScannerJobModalController class
     */
    export class PortScannerJobModalController {
        public static templateURL: string = "decorators/modals/port-scanner-job-modal.html";
        public static ID: string = "#id-port-scanner-job-modal";
        public static $name: string = "portScannerJobModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'ModalService', 'networkNodes'];

        private $scope: IPortScannerJobModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;
        private modalService: ngModal.IModalService;
        private networkNodes: Models.INetworkNode[];

        /**
         * Constructor
         */
        constructor($scope: IPortScannerJobModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    modalService: ngModal.IModalService,
                    networkNodes: Models.INetworkNode[]) {

            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.$scope = $scope;
            this.close = close;
            this.modalService = modalService;
            this.networkNodes = networkNodes;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                // checks the ports using a regular expression
                if ((this.$scope.selectedTarget === 'node' || (this.$scope.selectedTarget === 'ip' &&
                    Common.Utils.validateIPAddress(this.$scope.ipAddress))) &&
                    Common.Utils.validatePortList(this.$scope.portsRaw)) {

                    // creates the job info object
                    let jobInfo: Models.PortScannerJobInfo = new Models.PortScannerJobInfo();

                    if (this.$scope.selectedTarget === 'node') {
                        jobInfo.networkElementHref = Common.Utils.idFromHref(this.$scope.selectedNode.href);
                        jobInfo.networkNode = this.$scope.selectedNode;
                        jobInfo.networkNodeType = this.$scope.selectedNode.type;
                    }
                    else
                        jobInfo.ipAddress = this.$scope.ipAddress.replace(/ /g, ''); // remove blank spaces

                    jobInfo.protocol = this.$scope.protocol;
                    jobInfo.portsRaw = this.$scope.portsRaw.replace(/ /g, ''); // remove blank spaces

                    this.close(jobInfo);
                }
            };

            this.$scope.onNodeCheck = (): void => {
                if (!this.$scope.selectedNode) {
                    this.selectNetworkNode(this.$scope.selectedNode);
                }
            };

            this.$scope.selectNode = (): void => {
                this.selectNetworkNode(this.$scope.selectedNode);
                this.$scope.selectedTarget = 'node';
            };
        }

        private selectNetworkNode(selectedNode: Models.INetworkNode): void {
            this.modalService.showModal({
                    templateUrl: Application.Controllers.SearchNodeModalController.templateURL,
                    controller: Application.Controllers.SearchNodeModalController.$name,
                    inputs: {
                        networkNodes: this.networkNodes,
                    },
                }).then((modalNode: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.SearchNodeModalController.ID,
                                                        {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modalNode.close.then((node: Models.INetworkNode) => {
                        modalElem.hide();
                        if (node) {
                            this.$scope.selectedNode = node;
                        } else {
                            if (!this.$scope.selectedNode) {
                                this.$scope.selectedTarget = 'ip';
                            }
                        }
                    });
                });
        }
    }
}
